import gql from 'graphql-tag';

import client from '../graphqlAPI';

const COMMENTS_REMOVE = gql`
  mutation Post($commentId: String!, $restore: Boolean) {
    commentRemove(commentId: $commentId, restore: $restore) {
      result
      error
    }
  }
`;

const commentRemove = async ({ commentId, restore }) => {
  try {
    const result = await client
      .mutate({
        mutation: COMMENTS_REMOVE,
        variables: { commentId, restore },
        fetchPolicy: 'no-cache',
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const {
      data: { commentRemove: commentRemoveData },
    } = result;

    if (commentRemoveData) {
      return commentRemoveData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: commentRemove`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: commentRemove Error: ${error}`);
    return null;
  }
};

export default commentRemove;
